import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// Drives the DSR detail slide-in panel via the `?dsr=<id>` URL param so that
// browser back closes the panel and dashboard URLs are bookmarkable. Used by
// every dashboard surface that opens the panel (Supervisor Recent DSRs,
// Safety Manager Recent Safety / Good Catch, AlertsPage source-DSR link).
export function useDsrPanel() {
  const [params, setParams] = useSearchParams();
  const dsrId = params.get('dsr');

  const openDsr = useCallback(
    (id: string) => {
      setParams((prev) => {
        const next = new URLSearchParams(prev);
        next.set('dsr', id);
        return next;
      });
    },
    [setParams],
  );

  const closeDsr = useCallback(() => {
    setParams((prev) => {
      const next = new URLSearchParams(prev);
      next.delete('dsr');
      return next;
    });
  }, [setParams]);

  return { dsrId, openDsr, closeDsr };
}
